import React, { Component } from 'react'
import Responsive from '../../../components/Responsive';
import { translate } from '../../../utils/useful';
import SingleVideo from './SingleVideo';
import DataGrid from "../../../components/DataGrid";
import AllVideos from './AllVideos';


export default class ViewVideo extends Component {
    state = {
        video: [
            { src: '/images/video/videoBcg.mp4', cover: '/images/video/vid1.jpg', title: 'Hair Stylist' },
            { src: '', cover: '/images/video/vid2.jpg', title: 'About Salon' },
            { src: '', cover: '/images/video/vid3.jpg', title: 'Salon' },
            { src: '', cover: '/images/video/vid4.jpg', title: 'Hair Salon' },
            { src: '', cover: '/images/video/vid5.jpg', title: 'Hair Salon' },
            { src: '', cover: '/images/video/vid6.jpg', title: 'Hair Salon' },
            { src: '', cover: '/images/video/vid7.jpg', title: 'Hair Salon' },
            { src: '', cover: '/images/video/vid8.jpg', title: 'Hair Salon' },
            { src: '', cover: '/images/video/vid9.jpg', title: 'Hair Salon' },
            { src: '', cover: '/images/video/vid10.jpg', title: 'Tehran Salon' },
            { src: '', cover: '/images/video/vid11.jpg', title: 'Tehran Salon' },
            { src: '', cover: '/images/video/vid12.jpg', title: 'Tehran Salon' },
            { src: '', cover: '/images/video/vid13.jpg', title: 'Tehran Salon' },
            { src: '', cover: '/images/video/vid14.jpg', title: 'Tehran Salon' },
        ]
    }
    render() {
        return (
            <div className='h-100 scroll-no-scrollbar w-100 bg-gray-5'>
                <div className='flexcc py-3 bg-black' style={{ position: 'sticky', top: '0', right: '0', left: '0', zIndex: '9' }}>
                    <div className='flexc br-10 px-3 py-1' style={{ border: '1px solid #eee' }}>
                        <input placeholder={translate(`Search ...`)} className='transparent-input white' type="text" />
                        <img height="20px" src="/images/search-white.svg" alt="" />
                    </div>
                </div>
                {/* <div className='h-100  px-3 py-4 scroll-no-scrollbar w-100'> */}
                {/* <DataGrid hideLoader={true} marginBottom={'px-2 mb-3 flex-1'} width={this.props.width} isLoading={this.state.isLoadingData} data={this.state.video} component={AllVideos} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '6', lg: "4", xl: "3" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions }} /> */}
                {/* <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} /> */}
                {/* </div> */}
                <div className="d-flex flex-wrap" style={{ backgroundColor: '#3e3e3e' }}>
                    <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "8", xl: "8" }}>
                        <SingleVideo width={this.props.width} />
                    </Responsive>
                    <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '12', lg: "4", xl: "4" }}>
                        <div className='w-100 h-100 p-3' style={{ backgroundColor: '#252525' }}>
                            {this.state.video.map((prop, index) => {
                                return (
                                    <div className='d-flex mb-3'>
                                        <div className='flex-2 br-10 mrd-4' style={{ width: '180px', height: '120px' }}>
                                            <img style={{ objectFit: 'cover' }} className='w-100 h-100 br-10' src={prop.cover} alt="" />
                                        </div>
                                        <div className='flex-1'>
                                            <p className='color-white fw-600'>{prop.title}</p>
                                            <p className='color-white text-smallest'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, rem! Odit maxime magnam amet soluta!</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}
